import React from "react";
import { gtagSendEvent } from "../../pages";
import { DownloadButton } from "../Buttons/DownloadButton/DownloadButton";
import { StyledLink } from "../Buttons/StyledLink/StyledLink";
import * as styles from "./footer.module.scss";
import pdfProgramme from "../../../static/pdf/EAO-SPBR_synopsis-V2.pdf";

export const Footer: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <DownloadButton
        link={pdfProgramme}
        text={"Download Programme"}
        className={styles.download}
        onClick={() => gtagSendEvent("download_program", "mobile_fixed")}
      />
      <StyledLink
        link={" https://eao.org/eao-spring-break-2022/ "}
        text={"register now"}
        className={styles.button}
        onClick={() => gtagSendEvent("register", "mobile_fixed")}
      />
    </div>
  );
};
